import React from 'react';
import PropTypes from 'prop-types';
import { POPUP } from 'utils/constants/popup';
import { ReactComponent as MessageIcon } from 'assets/icons/message-text.svg';
import app from 'new-ui/app';
import './style.css';

const AssistanceButton = ({ title = 'Need Assistance?', onClick }) => {
  return (
    <div
      className="assistance-btn"
      onClick={() => {
        app.setPopup(POPUP.ASSISTANCE_CHAT);
        if (onClick) {
          onClick();
        }
      }}
    >
      <MessageIcon />
      <span className="label">
        {title}
      </span>
    </div>
  );
};

AssistanceButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default AssistanceButton;
